import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as ReactDOM from 'react-dom';
import classNames from 'classnames';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import { formatFioForAvatar } from '../../../utils/formatters';
import './DriverLogPage.scss';
import { DriverBox } from './ViewBlocks/DriverBox';
import { TransportBox } from './ViewBlocks/TransportBox';
import { WayBillBox } from './ViewBlocks/WayBillBox';
import VisitBox from './ViewBlocks/VisitBox';
import { ViolationBox } from './ViewBlocks/ViolationBox';
import { OrderServiceBox } from './ViewBlocks/OrderServiceBox';
import { CarrierBox } from './ViewBlocks/CarrierBox';
import { getDriverData } from '../reducer';
import { DRIVER_MENU } from '../../../configs';

export function DriverLogDetails(props) {
  const { onClose, id } = props;
  const [selected, setSelected] = useState('driver');
  const {
    driverCard,
  } = useSelector(getDriverData);

  const {
    formatMessage,
  } = intlShape;

  function HeaderInfo() {
    const headerInfoBlock = document.getElementById('header-info-block');
    return headerInfoBlock ? (ReactDOM.createPortal(
      <div className="sub-page-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev" onClick={onClose}>Просмотр карточки водителя</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current">{driverCard?.full_name}</span>
        </div>
      </div>,
      headerInfoBlock,
    )) : null;
  }

  return ReactDOM.createPortal(
    <div className="driver-log-card">
      <HeaderInfo />
      <div className="dlc-container">
        <div className="dlc-menu">
          <div className="dlc-menu-avatar">
            {formatFioForAvatar({ last_name: driverCard?.driver_last_name, first_name: driverCard?.driver_first_name, middle_name: driverCard?.driver_middle_name })}
          </div>
          <div className="dlc-menu-user-fio">
            {driverCard?.full_name}
          </div>
          <div className="dlc-menu-list">
            {Object.values(DRIVER_MENU).map((item, index) => (
              <div key={index} className={classNames('dlc-menu-list-item', { isActive: selected === item })} onClick={() => setSelected(item)}>
                <div className="dlc-menu-list-item-title">
                  <Icons customIcon icon={item} />
                  <div>{formatMessage({ id: `driver.card.menu.${item}` })}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        { selected === DRIVER_MENU.SERVICE ? <OrderServiceBox onClose={onClose} /> : null }
        { selected === DRIVER_MENU.CARRIER ? <CarrierBox onClose={onClose} driver_id={id} /> : null }
        { selected === DRIVER_MENU.VIOLATION ? <ViolationBox onClose={onClose} driver_id={id} /> : null }
        { selected === DRIVER_MENU.SHEETS ? <WayBillBox onClose={onClose} driver_id={id} /> : null }
        { selected === DRIVER_MENU.HISTORY ? <VisitBox onClose={onClose} driver_id={id} /> : null }
        { selected === DRIVER_MENU.DRIVER ? <DriverBox onClose={onClose} id={id} /> : null }
        {/* { selected === DRIVER_MENU.DRIVER ? ( */}
        {/*  <div className="dlc-stats"> */}
        {/*    <div className="f3">Статистика</div> */}
        {/*    <div className="dlc-stats-block"> */}
        {/*      <div className="dlc-stats-block-title">Поездки</div> */}
        {/*      <div className="dlc-stats-block-container"> */}
        {/*        <div className="dlc-stats-block-container-value">26</div> */}
        {/*        <div className="dlc-stats-block-container-title">Сегодня</div> */}
        {/*      </div> */}
        {/*      <div className="dlc-stats-block-container"> */}
        {/*        <div className="dlc-stats-block-container-value">1 354</div> */}
        {/*        <div className="dlc-stats-block-container-title">За месяц</div> */}
        {/*      </div> */}
        {/*    </div> */}
        {/*    <div className="dlc-stats-block"> */}
        {/*      <div className="dlc-stats-block-title variant-1">Количество часов</div> */}
        {/*      <div className="dlc-stats-block-container"> */}
        {/*        <div className="dlc-stats-block-container-value">03:02:53</div> */}
        {/*        <div className="dlc-stats-block-container-title">Сегодня</div> */}
        {/*      </div> */}
        {/*      <div className="dlc-stats-block-container"> */}
        {/*        <div className="dlc-stats-block-container-value">201:56:21</div> */}
        {/*        <div className="dlc-stats-block-container-title">За месяц</div> */}
        {/*      </div> */}
        {/*    </div> */}
        {/*    <div className="dlc-stats-block"> */}
        {/*      <div className="dlc-stats-block-title variant-2">Нарушения</div> */}
        {/*      <div className="dlc-stats-block-container"> */}
        {/*        <div className="dlc-stats-block-container-value">0</div> */}
        {/*        <div className="dlc-stats-block-container-title">Сегодня</div> */}
        {/*      </div> */}
        {/*      <div className="dlc-stats-block-container"> */}
        {/*        <div className="dlc-stats-block-container-value">15</div> */}
        {/*        <div className="dlc-stats-block-container-title">За месяц</div> */}
        {/*      </div> */}
        {/*    </div> */}
        {/*  </div> */}
        {/* ) : null } */}
        { selected === DRIVER_MENU.VEHICLE ? <TransportBox onClose={onClose} driverId={id} /> : null }
      </div>
    </div>,
    document.getElementById('app-content-children'),
  );
}
